module.exports = __webpack_public_path__ + "media/DeepOnceVideo.5ecdd226.mp4";